import { fetch } from '@financial-tool/fetch';
import { WorkspaceUser } from '../../company/types';

export default function getWorkspaceUsers(workspaceId: string) {
  return fetch.get<WorkspaceUser[]>(`/workspaces/${workspaceId}/members`);
}
